import {
  ThemeProvider,
  Theme,
  StyledEngineProvider
} from '@mui/material/styles'
import { useEffect, useState } from 'react'
import { getTheme } from './theme'
import { WrapperProps } from '../../components'
import { CLIENT_THEME_FILE_PATH, extend, fetchData } from '../../utils'
import variables from './variables'
import { createContextFactory } from '../utils'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const [useClientTheme, ClientThemeContextProvider] =
  createContextFactory<Theme>('useClientTheme', 'ClientThemeContextProvider')

const ClientThemeProvider = ({ children }: WrapperProps) => {
  const [theTheme, setTheTheme] = useState<Theme>(getTheme())

  useEffect(() => {
    const fetchTheme = async () => {
      const clientThemeData = await fetchData(CLIENT_THEME_FILE_PATH)
      extend(variables, clientThemeData) // extending base theme by reference
      setTheTheme(getTheme())
    }
    fetchTheme()
  }, [])

  return (
    <ClientThemeContextProvider value={theTheme}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theTheme}>{children}</ThemeProvider>
      </StyledEngineProvider>
    </ClientThemeContextProvider>
  )
}

export { ClientThemeProvider, useClientTheme }
